export const SERVICE_ACTION_COLLECTION_API_RESOURCE_NAME = 'service-action-collections';
